module.exports = __webpack_public_path__ + "static/media/tommy2.1cfd36e5.svg";